exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".valuesContainer-Hzm2q{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:13px;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-column-gap:10px;-moz-column-gap:10px;column-gap:10px;row-gap:10px}.selectedItem-1A1mo{padding:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#eaf6ff;-webkit-column-gap:10px;-moz-column-gap:10px;column-gap:10px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.selectedItem-1A1mo>svg{cursor:pointer;font-size:20px}.customOption-2x2JI{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-column-gap:12px;-moz-column-gap:12px;column-gap:12px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:14px}", ""]);

// exports
exports.locals = {
	"valuesContainer": "valuesContainer-Hzm2q",
	"selectedItem": "selectedItem-1A1mo",
	"customOption": "customOption-2x2JI"
};